import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import CommonReactTable from '../CommonUtils/CommonReactTable';
import { CommonAxiosGet } from '../CommonUtils/CommonAxios';
import { config } from '../CommonUtils/CommonURLS';
import { FaFilePdf } from 'react-icons/fa';
import { viewImage } from '../CommonUtils/viewImage';
import CommonCardHeader from '../CommonUtils/CommonCardHeader';

export default function DownloadProceedings() {

    const [proceedingData, setProceedingData] = useState([]);
    function getproceedingsData() {
        CommonAxiosGet(config.url.STU_URL + "getproceedingpdf").then(res => {
            if (res?.data?.status === true) {
                setProceedingData(res?.data?.scode === "01" ? res.data?.data : []);
            } else {
                setProceedingData([]);
            }
        })
    }
    useEffect(() => {
        getproceedingsData();
    }, [])

    const columns = [
        {
            id: "slNo",
            header: "S.No",
            cell: ({ row }) => row.index + 1,
        },
        {
            id: "count",
            header: "Students Count",
            accessorKey: "count",
            meta: { style: { textAlign: "center" } },
        },
        {
            id: "final_pdf_sign",
            header: "Final PDF Sign",
            accessorKey: "final_pdf_sign",
            meta: { style: { textAlign: "center" } },
            cell: ({ row }) =>
                row.original.final_pdf_sign ? (
                    <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => viewImage(row.original.final_pdf_sign)} >
                        <FaFilePdf className="me-1" />
                        View PDF
                    </button>
                ) : (<span className="text-muted small">Not Uploaded</span>),
        },
    ];
    return (
        <div>
            <Container fluid className="py-4">
                <section className="workflow-section-surface">
                    <CommonCardHeader title="Download Proceedings" />
                    <div className="workflow-section-body">
                        {proceedingData?.length > 0 ? (
                            <CommonReactTable
                                data={proceedingData}
                                columns={columns}
                                filename="DownloadProceedings"
                                headerName="Download Proceedings"
                                showFooter={false}
                                showPagination={false}
                                showExcel={false}
                                showPrint={false}
                                excelFileName="Download Proceedings"
                            />) : (
                            <div style={{ textAlign: "center", color: "red", fontWeight: "bold" }} > ** No data Found ** </div>
                        )}
                    </div>
                </section>
            </Container>
        </div >
    )
}